export default __webpack_public_path__ + "static/media/hidden-table.9a6e12e3.svg";